import React, { useEffect, useRef, useState } from "react";
import {
  formBtn1,
  formBtn2,
  inputClass,
  pageClass,
  pageHeader,
} from "../Utils/CustomClasses";
import Table from "../Table/Table";
import AddGroups from "../Modals/AddGroups";
import { useNavigate } from "react-router-dom";
import {
  GetAllCompanyAPI,
  GetAllGroupsAPI,
  GetGroupsByCompanyAPI,
} from "../../API/Api";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import usePaginatedData from "../Utils/UsePagination";
import DeleteGroupModal from "../Modals/DeleteGroupModal";
import { useThemeColor } from "../Sidebar/SideBarApi";
import { toast } from "react-toastify";
import { IconEye } from "@tabler/icons-react";

export default function ViewGroups() {
  const { register, watch, reset,handleSubmit } = useForm();
  const themeColor = useThemeColor();
  const isFirstRender = useRef(true);
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const navigate = useNavigate();
  let companyId = watch("companyId");
  const initialFilterState = {
    p: 1,
    companyId:
      UserDetails?.role?.roleName == "SuperAdmin"
        ? ""
        : UserDetails?.company?._id,
  };
  const [filterObject, setFilterObject] = useState({ ...initialFilterState });
  const filterTimeout = useRef();
  const [Company, setCompany] = useState([]);
  const {
    filterData: groupsData,
    pageNo,
    nextIsValid,
    prevIsValid,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    loader,
  } = usePaginatedData(1, 50, GetGroupsByCompanyAPI, filterObject);

  const tableColumns = [
    {
      field: "group_name",
      header: "Group Name",
      style: true,
      body: (row) => <h6>{row?.grpName || "-----"}</h6>,
    },
    {
      field: "Company_name",
      header: "Company Name",
      style: true,
      body: (row) => <h6>{row?.company?.companyName || "-----"}</h6>,
    },
    {
      field: "User",
      header: "User",
      style: true,
      body: (row) =>
        row?.users?.map((user) => (
          <h6>
            {user?.first_name} {user?.last_name || "----"}
          </h6>
        )),
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleNavigate(row);
            }}
            className="py-1 rounded-lg flex justify-center w-[1.40rem]"
          >
            <IconEye size={24} className="text-black" color="#000" stroke={1.5} />
          </button>
          <AddGroups edit={true} filterRecords={filterRecords} row={row} />
          <DeleteGroupModal row={row} filterRecords={filterRecords} />
        </div>
      ),
    },
  ];

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  const handleNavigate = (row) => {
    navigate("/detail-groups", { state: { rowdata: row } });
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Prevent first API call from `useEffect`
      return;
    }
    filterRecords();
  }, [filterObject]);
  const getallCompany = async (companyId) => {
    try {
      if (UserDetails?.role?.roleName == "SuperAdmin") {
        const res = await GetAllCompanyAPI(companyId);
        setCompany(res?.data?.filteredData);
      } else {
        setCompany([]);
      }
    } catch (err) {
      console.log("Error:", err);
    }
  };

  useEffect(() => {
    getallCompany(UserDetails?.company?._id);
  }, []);

  const filterSubmit = (data) => {
    if (!data.companyId) {
      toast.error("Please select a company name");
      return;
    }
    setFilterObject((prevState) => ({
      ...prevState,
      companyId: data?.companyId ? data?.companyId : "",
    }));
  };

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex flex-col items-center gap-2 md:flex-row md:items-center md:justify-between">
            <h1 className={`${pageHeader}`}>View Groups</h1>
            <AddGroups
              filterRecords={filterRecords}
              edit={false}
              Company={Company}
            />
          </div>
          {UserDetails?.role?.roleName == "SuperAdmin" && (
            <div className="bg-white rounded-xl">
              <form
                onSubmit={handleSubmit(filterSubmit)}
                className="flex flex-col lg:flex-row gap-3 mt-3"
              >
                {/* FILTERS DIV */}
                <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                  <div>
                    <select
                      name="company_id"
                      className={`${inputClass} !bg-slate-100 ${
                        companyId == "" ? "text-slate-400" : ""
                      }`}
                      {...register("companyId")}
                    >
                      <option value="">Company Name</option>

                      {Company?.map((company) => (
                        <option
                          className="text-black"
                          key={company?._id}
                          value={company?._id}
                        >
                          {company?.companyName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* BUTTON DIV */}
                <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                  <button type="submit" className={`${formBtn1}`}>
                    Apply
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      reset();
                      setFilterObject(initialFilterState);
                    }}
                    className={`${formBtn2}`}
                  >
                    Clear
                  </button>
                </div>
              </form>
            </div>
          )}
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={groupsData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              loading={loader}
            />
          </div>
        </div>
      </div>
    </>
  );
}
